export const AUTOCOMPLETE_TYPES = {
  lastName: 'family-name',
  firstName: 'given-name',
  middleName: 'additional-name',
  name: 'name',
  tel: 'tel',
  email: 'email',
  address: 'street-address',
};
